export const _strictBucketNameRegex = /^(?!^xn--|.+-s3alias$)[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/; // https://stackoverflow.com/a/50484916 for this validation regex pattern

// XXX: We support all sorts of weird bucket names including periods "." for backward compatibility
export const bucketNameRegex = /^[a-z0-9]\.?([a-z0-9-]+\.?)+[a-z0-9]$/;
export const bucketNameMin = 3;
export const bucketNameMax = 63;

export function isValidBucketName(value: string): boolean {
    return bucketNameRegex.test(value) && value.length >= bucketNameMin && value.length <= bucketNameMax;
}
